import React, { useEffect, useState, FC } from 'react';
import { documentService, windowService } from '../../../../../utils/window.utils';
import { BreakpointsInPx } from '../../../../../constants/breakpoints.constants';
import Icon from '../../../icon';
import { iconSize } from '../../../../../constants/icon.constants';

export type TDropdownProps = Partial<{
  dropdownOptions?: {
    id?: string;
    title?: JSX.Element | string;
  }[];
  id?: string;
  handleOptionClick?: (selectedOptionInd) => void;
  selectedOptionInd?: number;
  className?: string;
}>;

const Dropdown: FC<TDropdownProps> = ({ dropdownOptions = [], id, handleOptionClick, selectedOptionInd: checkedOptInd = 0 }) => {
  const [shouldShowDropdown, setShouldShowDropdown] = useState(false);

  useEffect(() => {
    function closeDropDownOnOutsideClick(event): void {
      if (windowService()?.innerWidth < `${BreakpointsInPx['tbl-p']}`) return;
      if (event?.target?.getAttribute('data-is-filter-dropdown-switch') !== id) {
        setShouldShowDropdown(false);
      }
    }
    const docElement = documentService();
    if (!docElement?.body) return;
    docElement.addEventListener('click', closeDropDownOnOutsideClick, false);
    return (): void => docElement.removeEventListener('click', closeDropDownOnOutsideClick, false);
  }, []);

  if (!dropdownOptions.length) return <></>;

  return (
    <div className="filter-dropdown" data-is-filter-dropdown-switch={id} onClick={() => setShouldShowDropdown(!shouldShowDropdown)}>
      <span className="filter-dropdown__title">{dropdownOptions[checkedOptInd]?.title}</span>
      <Icon
        iconName={`arrow-chevron-${shouldShowDropdown ? 'up' : 'down'}`}
        size={iconSize['dsk']}
        color="light-black"
        extraClassName="filter-dropdown__icon"
      />
      {shouldShowDropdown && (
        <div className="filter-dropdown__option-wrapper">
          {dropdownOptions?.map((eachDropdownItem, index) => (
            <div className="filter-dropdown__option" key={eachDropdownItem.id} onClick={() => handleOptionClick?.(index)}>
              {eachDropdownItem.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
